import axios from "axios";
//getEmployeeBioData
import {
	SHOPDATA_LOADING,
	SHOPDATA_SAVING_FAILED,
	SHOPDATA_SAVING_SUCCESSED,
} from "./types";
export const loadShopData = (listdata) => (dispatch) => {
	dispatch({ type: SHOPDATA_LOADING });

	let formData = new FormData(); //formdata object
	console.log("loadNotifications data=", listdata);

	listdata.data.map((listdata) => {
		formData.append(listdata.name, listdata.value); //append the values with key, value pair
	});

	const token = localStorage.getItem("token");
	const config = {
		headers: {
			"x-auth-token": token,
			"content-type": "application/json",
		},
	};

	axios
		.post(listdata.url, formData, config)
		.then((response) => {
			dispatch({ type: SHOPDATA_SAVING_SUCCESSED, payload: response });

			console.log("loadNotifications=", response);
		})
		.catch((error) => {
			console.log(error);
			return dispatch({
				type: SHOPDATA_SAVING_FAILED,
				payload: error,
			});
		});
};
